import {useMutation} from "@apollo/client";
import {useNavigate} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Select} from "@/components/select/Select.tsx";
import {GQL_SELECT_SUBACCOUNT} from "@/lib/queries/accounts.ts";
import {Account} from "@/lib/types/accounts";
import {GenericResponse} from "@/lib/types/common.ts";

import styles from "./NavBarSubAccountSelect.module.scss";

export const NavBarSubAccountSelect = () => {
  const navigate = useNavigate();
  const {user, accountAccounts} = useCurrentUserContext();
  const [selectSubaccount, {client}] = useMutation<GenericResponse>(GQL_SELECT_SUBACCOUNT);

  if (accountAccounts.items.length === 0) return null;

  const onChangeHandler = async (account: Account | null) => {
    if (account) {
      await selectSubaccount({
        variables: {
          id: !account.is_subaccount ? null : account.id,
        },
      });
      Object.keys(localStorage)
        .filter((key) => key.endsWith("_filters"))
        .forEach((key) => localStorage.removeItem(key));
      await client.resetStore();
      navigate("/dashboard");
    }
  };

  return (
    <div className={styles.subAccountSelect}>
      <Select
        variant={"nav"}
        isSearchable={false}
        onChange={onChangeHandler}
        value={accountAccounts.items.find((account) => account.id === user!.account.id)}
        options={accountAccounts.items}
        getOptionValue={(option) => option.id.toString()}
        getOptionLabel={(option) => option.name}
      />
    </div>
  );
};
